export const endPoints = {
  TG_CHATBOT: '/v1/telegram-chat-bot/config',
  DELETE_TG_CHATBOT: '/v1/telegram-chat-bot/config',
  PATCH_TG_CHATBOT_USERS: '/v1/telegram-chat-bot/config/users',
  DELETE_TG_CHATBOT_USER: '/v1/telegram-chat-bot/config/user',
  GET_TG_CHATBOT_URL: '/v1/telegram-chat-bot/config/url',
  GET_EMPLOYEES: '/v1/lead/employee'
};
